import { getActionOption } from './getActionOption';

/**
 * Whether the given action (state token) requires a PIN (user_codes key). Pure — operates on the passed
 * actionOptions (no config lookup).
 * @param {Array} actionOptions - the capability's action options (from config)
 * @param {string} action - state token
 * @returns {boolean}
 */
export const isPinRequiredForAction = (actionOptions, action) => {
    return Boolean(getActionOption(actionOptions, action)?.requiresPin);
};
